import * as AWS from 'aws-sdk';
import { 
    BUCKET_NAME, 
    ACCESS_KEY_ID, 
    SECRET_ACCESS_KEY
} from '../config/s3Config';

export const s3LoadUrl = (avatarKey) => {
	const signedUrlExpireSeconds = 60 * 1
	const s3 = new AWS.S3({
		accessKeyId: ACCESS_KEY_ID,
		signatureVersion: 'v4',
		region: 'us-east-1',
		secretAccessKey: SECRET_ACCESS_KEY,
    });
    
	let url = s3.getSignedUrl('getObject', {
        Bucket: BUCKET_NAME,
        Key: avatarKey,
        Expires: signedUrlExpireSeconds
	});

	return url;
};
